import React, { Component } from "react";
import moment from 'moment';
import WindowedSelect from "react-windowed-select";
import DatePicker from 'react-datepicker'
import NominationData from './nomination-data-component';
import headerJson from '../services/nomination-header.json';
import NominationScreenStore from '../store/nomination-data-store';
import { SegmentedControl } from 'segmented-control';

import './nomination-component.scss';


class NominationCriteria extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nominationRole: '',
            userName: '',
            displayName: '',
            facData: [],
            selectedFacOption: '',
            dataAvailable: (new Date().getFullYear().toString() + "-" + new Date().getMonth(0).toString()),
            selectedMnthOption: '',
            selectedMovement: 'N/A',
            screenType: (this.props.path.includes('BorderFlow') ? 'BF' : 'E6'),
            showAdjustment: false,
            adjustmentEdit: '0',
            selectedVerbage: '',
            endDate: moment().add(1, 'months'),
            UOMOption: [{ value: 'E3M3', label: 'E3M3', default: true, division: 1 }, { value: 'MMCF/D', label: 'MMCF/D', division: 28.327 }],
            selectedUOM: { value: 'E3M3', label: 'E3M3', division: 1 },
            adjustmentDisabled: true,
            superDirty: true,
            updateAdjustment: false
        }
        this.textInput = React.createRef();
    }

    async componentDidMount() {
        let usr = await NominationScreenStore.getUserDetails();
        const headerData = headerJson.faclitiesProducts.filter(
            (opt) =>
                (opt.screenType === this.state.screenType)
                && (opt.role.includes(usr.nominationRole))
        );
        const facData = [];
        headerData.forEach(item => {
            facData.push({
                value: item["fact"], label: item["fact"],
                movement: item["movement"], adjustment: item["adjustment"],
                verbage: item["verbage"], startDate: item["startDate"]
            });
        });
        this.setState({
            userName: usr.userName,
            displayName: usr.displayName,
            nominationRole: usr.nominationRole,
            facData: facData
        });
    }

    handleFacSelect = (facOption) => {
        let selectedMovement = 'N/A';
        let showAdjustment = facOption?.adjustment;
        let selectedVerbage = facOption?.verbage;
        let startDate = facOption?.startDate;

        if (this.state.screenType === 'BF') {
            selectedMovement = facOption.movement
        }
        this.setState({
            selectedFacOption: facOption, selectedMovement: selectedMovement,
            showAdjustment: showAdjustment, selectedVerbage: selectedVerbage,
            dataAvailable: startDate, superDirty: true
        })
    }

    handleMnthSelect = (mnthOption) => {
        if ((new Date(mnthOption) > new Date(new Date(this.state.dataAvailable) - 24 * 60 * 60 * 1000))
            && (new Date(new Date().getFullYear(), new Date().getMonth(0) + 1) >= new Date(mnthOption))) {
            this.setState({
                selectedMnthOption: mnthOption, superDirty: true, updateAdjustment: false
            })
        }
    }
    handleUOMSelect = (uomOption) => {
        let newUOM = this.state.UOMOption.filter((val) => val.value === uomOption);
        newUOM = Object.keys(newUOM).length > 0 ? newUOM[0] : '';
        if (this.state?.selectedFacOption?.value === 'TransCanada' || this.state?.selectedFacOption?.value === 'Foothills') {
            this.setState({
                selectedUOM: newUOM, superDirty: true, updateAdjustment: false
            });
        }
    }
    updateAdjustInv = (data) => {
        if (this.state.nominationRole === "ASSET") {
            this.setState({ adjustmentDisabled: false, superDirty: false, updateAdjustment: false });
        }
        this.setAdjustInv(data);
    }
    setAdjustInv(value) {
        if (this.state.showAdjustment) {
            if (typeof value == 'undefined' || value == null || value == ''
                || isNaN(value.toString().replace(/,/g, '').replace(/\(/g, '').replace(/\)/g, ''))) {
                value = 0;
            }
            value = Number(value.toString()
                .replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, ''));
            var text = "";
            var isNegative = false;
            if (!isNaN(value)) {
                value = Math.round((value + Number.EPSILON) * 100) / 100;
                isNegative = (value < 0);
                value = Math.round(value);
                text = Math.abs(value).toLocaleString(undefined, { minimumFractionDigits: 0 });
            }
            this.textInput.current.value = (isNegative ? "(" + text + ")" : text);
            return value;
        } else return;
    }

    onStopAdjustmentEditing = (e) => {
        const oldVal = this.state.adjustmentEdit;
        const newVal = this.setAdjustInv(e.target.value);
        if (oldVal !== newVal) {
            this.setState({ adjustmentEdit: newVal, superDirty: true, updateAdjustment: true });
        }
    }

    onChangeAdjustment = (e) => {
        var value = e.target.value;
        if (typeof value == 'undefined' || value == null || value == ''
            || (!['-', '.', '-.', '(', '(.'].includes(value)
                && isNaN(value.toString().replace(/,/g, '').replace(/\(/g, '')
                    .replace(/\)/g, '')))) { value = ''; }
        this.textInput.current.value = value;
    }
    getScreenDetails = () => {
        const path = this.props.path.split("/");
        const pathName = path[path.length - 1];
        const screen = this.props.CommonStore.screenDetails.find((i) => i.screen.name === pathName);
        return screen;
    }

    render() {
        const {
            screenType, facData, selectedFacOption, showAdjustment, dataAvailable, selectedMnthOption,
            selectedMovement, selectedVerbage, endDate, UOMOption, adjustmentDisabled
        } = this.state;
        return (
            <>
                <div className='nmntn-row'>
                    <h3 className="nmntn-title">Nominations</h3>
                </div>
                <div className='nmntn-row'>
                    <div className="nmntn-div-style">{screenType === 'BF' ? 'Facility/Pipeline' : 'Product'}</div>
                    <div className="mandatory-icon-style">&nbsp;*</div>
                    <div className="nmntn-select">
                        <WindowedSelect
                            options={facData}
                            onChange={this.handleFacSelect}
                            value={selectedFacOption}
                        />
                    </div>
                    {
                        (selectedFacOption !== '') && (
                            <>
                                <div className="nmntn-div-style">Month & Year</div>
                                <div className="mandatory-icon-style">&nbsp;*</div>
                                <div className="nmntn-select">
                                    <DatePicker
                                        gridID={"MonthYearDropdown"}
                                        selected={selectedMnthOption}
                                        onChange={this.handleMnthSelect}
                                        dateFormat="MMM-yyyy"
                                        showMonthYearPicker
                                        minDate={new Date(dataAvailable)}
                                        maxDate={new Date(endDate)}
                                    />
                                </div>
                            </>)
                    }
                    {
                        (screenType === 'BF') && (
                            <>
                                <div className="nmntn-div-style">Movement Type</div>
                                <div className="nmntn-text">{selectedMovement}</div>
                                <div className="nmntn-div-style mandatory-icon-style">{selectedVerbage}</div>
                            </>)
                    }
                    {
                        showAdjustment && (<>
                            <div className="nmntn-div-style">Adjusted Inventory </div>
                            <div>
                                <input type="text" className="nmntn-input" ref={this.textInput}
                                    disabled={adjustmentDisabled ? "disabled" : ""}
                                    onBlur={(e) => { this.onStopAdjustmentEditing(e) }}
                                    onChange={(e) => { this.onChangeAdjustment(e) }} />
                            </div>
                        </>)
                    }
                    {
                        (selectedFacOption !== '' && (selectedFacOption?.value === 'TransCanada'
                            || selectedFacOption?.value === 'Foothills')) && (
                            <>
                                <div className="nmntn-div-style">UOM</div>
                                <div className="mandatory-icon-style">&nbsp;</div>
                                <div className="nmntn-select">
                                    <SegmentedControl options={UOMOption}
                                        name="uomSlicer"
                                        setValue={this.handleUOMSelect}
                                        className="nmntn-segmented-control" />
                                </div>
                            </>
                        )
                    }
                </div>
                {
                    ((selectedFacOption !== '') && (selectedMnthOption !== ''))
                    && (<NominationData {...this.state} screenDetails={this.getScreenDetails()} updateAdjustInv={this.updateAdjustInv} />)
                }
            </>
        )
    }
}
export default NominationCriteria;